import { Directive, ElementRef, HostListener, Input, forwardRef } from '@angular/core';
import { LgvTSHelper } from '../utility/ts-helper';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

@Directive({
    selector: 'input[matInputWithComma]',
    providers: [
        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MatInputWithCommaDirective },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MatInputWithCommaDirective),
            multi: true,
        }
    ]
})
export class MatInputWithCommaDirective {
    private _value: string | null;
    @Input() decimalPlace = 0;
    constructor(private elementRef: ElementRef<HTMLInputElement>,
    ) {
    }


    get value(): string | null {
        return this._value;
    }

    @Input('value')
    set value(value: string | null) {
        this._value = value;
        this.formatValue(value);
    }

    private formatValue(value: string | null) {
        if (value !== null && value !== undefined) {
            this.elementRef.nativeElement.value = LgvTSHelper.numberWithCommas((+value).toFixed(this.decimalPlace));
        } else {
            this.elementRef.nativeElement.value = '';
        }
    }

    private unFormatValue() {
        const value = this.elementRef.nativeElement.value;
        this._value = value.replace(/[^\d.-]/g, '');
        if (value) {
            this.elementRef.nativeElement.value = this._value;
        } else {
            this.elementRef.nativeElement.value = '';
        }
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value) {
        // here we cut any non numerical symbols    
        this._value = value.replace(/[^\d.-]/g, '');
        this._onChange(this._value);
    }

    @HostListener('blur')
    _onBlur() {
        this.formatValue(this._value); // add commas
    }

    @HostListener('focus')
    onFocus() {
        this.unFormatValue(); // remove commas for editing purpose
    }

    _onChange(value: any): void {
    }

    writeValue(value: any) {
        this._value = value;
        this.formatValue(this._value); // format Value
    }

    registerOnChange(fn: (value: any) => void) {
        this._onChange = fn;
    }

    registerOnTouched() {
    }

}
